(function () {
  "use strict";
  var REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function init(root) {
    if (root.dataset.hhInit) return;
    root.dataset.hhInit = "1";

    var scroller = root.querySelector(".hub-hero__cards");
    if (!scroller) return;
    var realLis = Array.prototype.slice.call(scroller.querySelectorAll(".hub-hero__card-li"));
    var n = realLis.length;
    if (!n) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll(".hub-hero__dot"));
    var counter = root.querySelector(".hub-hero__count b");
    var loop = n > 1;

    if (loop) buildClones(scroller, realLis);

    var lis = Array.prototype.slice.call(scroller.querySelectorAll(".hub-hero__card-li"));
    var cards = Array.prototype.slice.call(scroller.querySelectorAll(".hub-hero__card"));
    var total = cards.length;
    cards.forEach(function (c) { c.__video = c.querySelector(".hub-hero__video"); });

    var setW = loop ? (lis[n].offsetLeft - lis[0].offsetLeft) : 0;
    var active = -1;

    function setActive(i) {
      if (i === active) return;
      active = i;
      var real = ((i % n) + n) % n;
      for (var k = 0; k < total; k++) cards[k].classList.toggle("is-active", k === i);
      dots.forEach(function (d, k) {
        d.classList.toggle("is-active", k === real);
        d.setAttribute("aria-selected", k === real ? "true" : "false");
      });
      if (counter) counter.textContent = ("0" + (real + 1)).slice(-2);
      cards.forEach(function (c) { if (c.__video) c.__video.pause && c.__video.pause(); });
      var cur = cards[i] && cards[i].__video;
      var isReal = !loop || (i >= n && i < n * 2);
      if (cur && isReal) cur.play && cur.play().catch(function () {});
    }

    function centered() {
      var s = scroller.getBoundingClientRect();
      var mid = s.left + s.width / 2;
      var best = 0, bestD = Infinity;
      for (var i = 0; i < total; i++) {
        var r = cards[i].getBoundingClientRect();
        var d = Math.abs((r.left + r.width / 2) - mid);
        if (d < bestD) { bestD = d; best = i; }
      }
      return best;
    }

    function jump(dx) {
      var b = scroller.style.scrollBehavior;
      scroller.style.scrollBehavior = "auto";
      scroller.scrollLeft += dx;
      scroller.style.scrollBehavior = b;
    }

    function centerOn(i, smooth) {
      if (i < 0) i = 0;
      if (i > total - 1) i = total - 1;
      var r = cards[i].getBoundingClientRect();
      var s = scroller.getBoundingClientRect();
      var dx = (r.left + r.width / 2) - (s.left + s.width / 2);
      if (smooth && !REDUCED) scroller.scrollBy({ left: dx, behavior: "smooth" });
      else jump(dx);
    }

    var raf = 0, settle = 0;
    function track() { raf = 0; setActive(centered()); }
    function reposition() {
      if (!loop) return;
      var c = centered();
      if (c < n) { jump(setW); track(); }
      else if (c >= n * 2) { jump(-setW); track(); }
    }
    function onScroll() {
      if (!raf) raf = requestAnimationFrame(track);
      clearTimeout(settle);
      settle = setTimeout(reposition, 130);
    }
    scroller.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", function () {
      setW = loop ? (lis[n].offsetLeft - lis[0].offsetLeft) : 0;
      onScroll();
    });

    var prev = root.querySelector("[data-hh-prev]"), next = root.querySelector("[data-hh-next]");
    var startIdx = loop ? n : 0;
    if (prev) prev.addEventListener("click", function () { centerOn((active < 0 ? startIdx : active) - 1, true); });
    if (next) next.addEventListener("click", function () { centerOn((active < 0 ? startIdx : active) + 1, true); });
    dots.forEach(function (d, i) { d.addEventListener("click", function () { centerOn(loop ? n + i : i, true); }); });

    if (!REDUCED && "IntersectionObserver" in window) {
      root.classList.add("hh-anim");
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { root.classList.remove("hh-anim"); io.disconnect(); } });
      }, { threshold: 0.12 });
      io.observe(root.querySelector(".hub-hero__intro") || root);
    }

    requestAnimationFrame(function () {
      if (loop) centerOn(n, false);
      track();
    });
  }

  function buildClones(scroller, realLis) {
    var before = document.createDocumentFragment();
    var after = document.createDocumentFragment();
    realLis.forEach(function (li) {
      before.appendChild(prepClone(li));
      after.appendChild(prepClone(li));
    });
    scroller.appendChild(after);
    scroller.insertBefore(before, scroller.firstChild);
  }

  function prepClone(li) {
    var c = li.cloneNode(true);
    c.setAttribute("aria-hidden", "true");
    var a = c.querySelector(".hub-hero__card");
    if (a) a.setAttribute("tabindex", "-1");
    Array.prototype.forEach.call(c.querySelectorAll("video"), function (v) {
      var poster = v.getAttribute("poster");
      var img = document.createElement("img");
      if (poster) img.src = poster;
      img.alt = "";
      img.loading = "lazy";
      img.decoding = "async";
      v.parentNode.replaceChild(img, v);
    });
    Array.prototype.forEach.call(c.querySelectorAll("img"), function (img) {
      img.loading = "lazy";
      img.removeAttribute("fetchpriority");
    });
    return c;
  }

  function boot() { document.querySelectorAll(".hub-hero").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", function (e) {
    var el = e.target.querySelector(".hub-hero"); if (el) init(el);
  });
})();

(function () {
  function typePrompt(scope) {
    var nodes = (scope || document).querySelectorAll('.hub-hero__prompt-text');
    nodes.forEach(function (el) {
      if (el.dataset.hhTyped) return;
      el.dataset.hhTyped = '1';
      var caret = el.parentNode.querySelector('.hub-hero__caret');
      var chars = Array.from(el.textContent);
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      el.textContent = '';
      if (caret) caret.classList.add('is-on');
      var i = 0;
      (function tick() {
        if (i >= chars.length) {
          if (caret) setTimeout(function () { caret.classList.add('is-fade'); }, 1400);
          return;
        }
        var ch = chars[i++];
        el.textContent += ch;
        var d = 65 + Math.random() * 75;
        if (ch === ' ') d += 50;
        if (ch === '\u2026') d += 260;
        setTimeout(tick, d);
      })();
    });
  }
  function start() { setTimeout(function () { typePrompt(); }, 420); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (e) { typePrompt(e.target); });
})();
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var seals = document.querySelectorAll('.hub-hero__seal-img');
  if (!seals.length) return;
  if (!('IntersectionObserver' in window)) {
    seals.forEach(function (s) { s.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });
  seals.forEach(function (s) { io.observe(s); });
})();